import {useQueryClient} from "@tanstack/react-query";
import {useToastMessagesStore} from "@/Stores/ToastMessagesStore";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import {can} from "@/Util/permissionChecks";
import {useNavigate} from "react-router-dom";
import {useCreateGtaRate} from "@/Service/Api/V1/ApiHooks/GtaRates/useCreateGtaRate";
import GtaRateForm, {GtaRateFormData} from "@/Components/Forms/GtaRateForm";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {sleep, url} from "@/Helpers/general";

const CreateGtaRatePage = () => {
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const {mutateAsync: createGtaRate, isPending} = useCreateGtaRate();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const handleCreateGtaRate = async (data: GtaRateFormData) => {
        await createGtaRate({
            StoreGtaRequest: data
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.gtaRates._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'GTA Rate created',
                    detail: 'GTA Rate has been created successfully',
                });
                await sleep(2000);
                navigate(url('gta-rates'));
            },
            onError: async (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'GTA Rate creation failed',
                    detail: `GTA Rate creation failed ${error.message}`,
                });
            }
        });
    };

    return (
        <PageLayout>
            <GtaRateForm
                onSubmit={handleCreateGtaRate}
                isProcessing={isPending}
                onSubmitButtonLabel='Create GTA Rate'
                onSubmitButtonDisabled={!can('create:gta')}
            />
        </PageLayout>
    );
};

export default CreateGtaRatePage;